// extracted by mini-css-extract-plugin
export default {"container":"UUUemoPD6TNju0uEJit7"};